import * as React from 'react';
import { InjectedTranslateProps, translate } from 'react-i18next';
import {
  Box,
  Header,
  IconCard,
  Clock,
  UserCard,
} from '@wix/social-groups-common';
import { AvatarSize } from 'wix-ui-tpa/Avatar';
import classnames from 'classnames';
import { Group, memberWrapper } from '@wix/social-groups-api';
import { ApiTypes } from '@wix/social-groups-api/dist/src/types';
import * as moment from 'moment';
import { PrivacyMap } from '../../Privacy/PrivacyMap';

import styles from '../About.st.css';
import infoStyles from './GroupInfo.st.css';

interface GroupInfoProps {
  group: ApiTypes.v1.GroupResponse;
}

const getTimeFromCreateDate = (d: Date) => {
  return moment(d).from(moment.now());
};

const GroupInfoComponent = (props: GroupInfoProps & InjectedTranslateProps) => {
  const { t, group } = props;
  const g = Group.getGroupResponseWrapper(group);
  const privacy = g.getPrivacy();
  const createdAt = getTimeFromCreateDate(g.getCreatedDate());
  const { title, icon, label } = PrivacyMap[privacy];
  const { name, imageUrl } = memberWrapper(group.createdBy);
  return (
    <Box className={classnames(styles.root, infoStyles.root)}>
      <div className={styles.header}>
        <Header>{t('groups-web.group-info')}</Header>
      </div>
      <div className={infoStyles.wrapper}>
        <div className={infoStyles.row}>
          <IconCard
            icon={<div className={infoStyles.groupTypeIcon}>{icon}</div>}
            title={t(title)}
            subtitle={t(label)}
          />
        </div>
        <div className={infoStyles.row}>
          <IconCard
            icon={<Clock />}
            title={`${t('groups-web.created')} ${createdAt}`}
          />
        </div>
        <div className={infoStyles.createdByRow}>
          <UserCard
            subtitle={`${t('groups-web.createdBy')}:`}
            name={name.nick || t('groups-web.member.anonymous')}
            pic={imageUrl}
            avatarSize={AvatarSize.small}
            reverse
          />
          {/* <ChatIcon className={infoStyles.chatIcon} /> */}
        </div>
      </div>
    </Box>
  );
};

export const GroupInfo = translate()(GroupInfoComponent) as React.ComponentType<
  GroupInfoProps
>;
